import WineABVIcon from './WineABVIcon';

export default WineABVIcon;
